import NavPublic from "./NavPublic";
//import Likes from "./Likes";
import CommentsPublic from "./CommentsPublic";
//import RemoveButton from "./RemoveButton";
//import { ToastContainer, toast } from "react-toastify";
//import { toast } from "react-toastify";


import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { API , graphqlOperation } from 'aws-amplify'
//import { createTodo, updateTodo, deleteTodo } from '../graphql/mutations'
import { todosByDate, listMetrics, getMetric  } from '../graphql/queries'
import {
    //Flex,
  //  Heading,
    Image,
  //  View,
  } from "@aws-amplify/ui-react";
  import img1 from "../logo192.png";
  import logo from '../logo.svg';


function useInterval(callback, delay) {
    const savedCallback = useRef();
  
    // Remember the latest callback.
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);
  
    // Set up the interval.
    useEffect(() => {
      let id = setInterval(() => {
        savedCallback.current();
      }, delay);
      return () => clearInterval(id);
    }, [delay]);
  }


const Home = () => {
    const navigate = useNavigate();
    //function snotify(note) {toast.success(note);};
    //function inotify(note) {toast.info(note)};
    //function enotify(note) {toast.error(note)};
    //function wnotify(note) {toast.warning(note)};

   

    const [todos, setTodos] = useState([]);
    const [metricId, setMetricId] = useState('');
    const [bot1, setBot1] = useState('0');
    const [bot2, setBot2] = useState('0');
    const [bot3, setBot3] = useState('0');
    const [bot4, setBot4] = useState('0');
    //const [threadList, setThreadList] = useState([]);
    //const [threadList2, setThreadList2] = useState([]);

    //const [thread, setThread] = useState("");
    //const [thread2, setThread2] = useState("");
    const [loader, setLoader] = useState("1")

      //AutoUpdate from backend
      var tmpcnt = 60000;
      useInterval(() => {
       
          fetchTodos();
          fetchMetrics();
  
      }, tmpcnt);
    
   

    //👇🏻 The useEffect Hook
    useEffect(() => {

        const fetchTodos2 = async () => {
            try {
                const todoData = await API.graphql(graphqlOperation( todosByDate,   {type: 'todo' ,  sortDirection: 'ASC'}   ));
               // console.log(todoData);
               // const todoList = todoData.data.listTodos.items;
               const todoList = todoData.data.todosByDate.items;
                //console.log('todo list', todoList);
                setTodos(todoList);
                setLoader('0');
            } catch (error) {
                console.log('error on fetching todos', error);
            }
        };
    




        const fetchMetrics2 = async () => {
          
            try {
                const todoData = await API.graphql(graphqlOperation( listMetrics ));
             //   console.log(todoData);
               // const todoList = todoData.data.listTodos.items;
           //    const todoList = todoData.data.listMetrics.items;
              //  console.log('metrics list', todoList);
              //  setMetrics(todoList);
             //   setLoader('0');
              
                var tmpId = todoData.data.listMetrics.items[0].id
                setMetricId(tmpId);
                setBot1(todoData.data.listMetrics.items[0].bot1);
                setBot2(todoData.data.listMetrics.items[0].bot2);
                setBot3(todoData.data.listMetrics.items[0].bot3);
                setBot4(todoData.data.listMetrics.items[0].bot4);
  
  
  
            } catch (error) {
                console.log('error on fetching metrics', error);
            }
  
  
         
  
  
  
        };
  



        fetchTodos2();
        fetchMetrics2();
     
    }, [navigate]);

    const fetchTodos = async () => {
        try {
            const todoData = await API.graphql(graphqlOperation( todosByDate,   {type: 'todo' ,  sortDirection: 'ASC'}   ));
           // console.log(todoData);
           // const todoList = todoData.data.listTodos.items;
           const todoList = todoData.data.todosByDate.items;
            //console.log('todo list', todoList);
            setTodos(todoList);
            setLoader('0');
        } catch (error) {
            console.log('error on fetching todos', error);
        }
    };



    const fetchMetrics = async () => {
        try {
               //refresh metrics
                var replyData = await API.graphql(graphqlOperation(getMetric    ,   {id: metricId }  ));
           //     console.log(replyData);
           setBot1(replyData.data.getMetric.bot1);
           setBot2(replyData.data.getMetric.bot2);
           setBot3(replyData.data.getMetric.bot3);
           setBot4(replyData.data.getMetric.bot4);
        } catch (error) {
            console.log('error on fetching update list', error);
        }
    };
    

//function blank(){};



/////////////////////////////////////////////////////////////////////////////////////////////////
/*
 * Date Format 1.2.3
 * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
 * MIT license
 *
 * Includes enhancements by Scott Trenda <scott.trenda.net>
 * and Kris Kowal <cixar.com/~kris.kowal/>
 *
 * Accepts a date, a mask, or a date and a mask.
 * Returns a formatted version of the given date.
 * The date defaults to the current date/time.
 * The mask defaults to dateFormat.masks.default.
 */

var dateFormat = function () {
	var	token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
		timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
		timezoneClip = /[^-+\dA-Z]/g,
		pad = function (val, len) {
			val = String(val);
			len = len || 2;
			while (val.length < len) val = "0" + val;
			return val;
		};

	// Regexes and supporting functions are cached through closure
	return function (date, mask, utc) {
		var dF = dateFormat;

		// You can't provide utc if you skip other args (use the "UTC:" mask prefix)
		if (arguments.length == 1 && Object.prototype.toString.call(date) == "[object String]" && !/\d/.test(date)) {
			mask = date;
			date = undefined;
		}

		// Passing date through Date applies Date.parse, if necessary
		date = date ? new Date(date) : new Date;
		if (isNaN(date)) throw SyntaxError("invalid date");

		mask = String(dF.masks[mask] || mask || dF.masks["default"]);

		// Allow setting the utc argument via the mask
		if (mask.slice(0, 4) == "UTC:") {
			mask = mask.slice(4);
			utc = true;
		}

		var	_ = utc ? "getUTC" : "get",
			d = date[_ + "Date"](),
			D = date[_ + "Day"](),
			m = date[_ + "Month"](),
			y = date[_ + "FullYear"](),
			H = date[_ + "Hours"](),
			M = date[_ + "Minutes"](),
			s = date[_ + "Seconds"](),
			L = date[_ + "Milliseconds"](),
			o = utc ? 0 : date.getTimezoneOffset(),
			flags = {
				d:    d,
				dd:   pad(d),
				ddd:  dF.i18n.dayNames[D],
				dddd: dF.i18n.dayNames[D + 7],
				m:    m + 1,
				mm:   pad(m + 1),
				mmm:  dF.i18n.monthNames[m],
				mmmm: dF.i18n.monthNames[m + 12],
				yy:   String(y).slice(2),
				yyyy: y,
				h:    H % 12 || 12,
				hh:   pad(H % 12 || 12),
				H:    H,
				HH:   pad(H),
				M:    M,
				MM:   pad(M),
				s:    s,
				ss:   pad(s),
				l:    pad(L, 3),
				L:    pad(L > 99 ? Math.round(L / 10) : L),
				t:    H < 12 ? "a"  : "p",
				tt:   H < 12 ? "am" : "pm",
				T:    H < 12 ? "A"  : "P",
				TT:   H < 12 ? "AM" : "PM",
				Z:    utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
				o:    (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
				S:    ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
			};

		return mask.replace(token, function ($0) {
			return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
		});
	};
}();

// Some common format strings
dateFormat.masks = {
	"default":      "ddd mmm dd yyyy HH:MM:ss",
	shortDate:      "m/d/yy",
	mediumDate:     "mmm d, yyyy",
	longDate:       "mmmm d, yyyy",
	fullDate:       "dddd, mmmm d, yyyy",
	shortTime:      "h:MM TT",
	mediumTime:     "h:MM:ss TT",
	longTime:       "h:MM:ss TT Z",
	isoDate:        "yyyy-mm-dd",
	isoTime:        "HH:MM:ss",
	isoDateTime:    "yyyy-mm-dd'T'HH:MM:ss",
	isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
};

// Internationalization strings
dateFormat.i18n = {
	dayNames: [
		"Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",
		"Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
	],
	monthNames: [
		"Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
		"January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
	]
};

// For convenience...
Date.prototype.format = function (mask, utc) {
	return dateFormat(this, mask, utc);
};
////////////////////////////////////////////////////////////////////////////////////////////////








if (loader==='1') {
    var tmpH1 = true;
    var tmpH2 = false
} else {
    tmpH1 = false;
    tmpH2 = true
};

var totalTrolls = bot1 + bot2 + bot3 + bot4 + 100;

    return (
        <>
            <NavPublic />

        <div style={{backgroundColor:'black', minWidth:'96vw', color:'white', minHeight:'90vh'}}>

         <br></br>
              
              <span style={{fontSize:'32px', fontWeight:'bold'}}>
                
              <Image
  alt="img1"
  src={img1}
  backgroundColor="initial"
  height='18px'
  width='18px'
  borderRadius="2px"
  marginRight="10px"
  opacity="100%"
  //onClick={() => alert('📸 Say cheese!')}
/>
                
                general discussion board</span><br></br>
              <span hidden = {tmpH1} style={{fontSize:'14px', color:"yellow", opacity:'1'}}>trolls prevented: {totalTrolls} </span>  
         

            <span hidden = {tmpH1}>



            <div style={{display:"flex", flexDirection:'row' , justifyItems:'center' , justifyContent:'center' ,  alignItems:'center', textAlign:'center', paddingTop:'18px', rowGap:'15px', columnGap:'15px' }}>




</div>


<div className='thread__container'>
                    {todos.map((thread,idx) => (
                         <div  style={{	boxShadow: '0 0 0px 0px yellow', display: "flex", flexDirection:'column' , padding:"1vw",backgroundColor:'#416288', minWidth:'90vw', maxWidth:'90vw',  margin:'5px', borderRadius:"3px"}} key={`song${idx}`}>

                            <div style={{boxShadow: '0 0 0px 0px red', display:"flex", backgroundColor:'#416288', rowGap:'2vw', columnGap:'2vw', flexDirection:'row' , justifyItems:'flex-start' , justifyContent:'space-between',  alignItems:"center", textAlign:'center'}}>
                            
                            <div style={{ boxShadow: '0 0 0px 0px blue', display:"flex", flexDirection:'row' , minWidth:'48vw',maxWidth:'48vw', textAlign:'left', paddingLeft:'1vw', color:'white', rowGap:'15px', columnGap:'15px' }}>{thread.description}  </div>
                            <div style={{ boxShadow: '0 0 0px 0px yellow', display:"flex", flexDirection:'row' , minWidth:'23vw',maxWidth:'23vw', textAlign:'left', color:'white', fontSize:'12px'}}>updated: {dateFormat(thread.updatedAt, "mmm dd, yyyy @ h:MM:ss TT")}</div>

                            <div style={{boxShadow: '0 0 0px 0px yellow', display:"flex", rowGap:'2vw', columnGap:'2vw', flexDirection:'row' , justifyItems:'center' , justifyContent:'center' ,  alignItems:'center', textAlign:'center'}}>
                            <span > 
                            
                                <CommentsPublic
                                    numberOfComments={thread.rcount}
                                    threadId={thread.id}
                                    title={thread.description}
                                />
                            </span>
                            <span style={{paddingRight:'1vw'}}> 
                                
                                </span>
                                </div>

                            </div>
                        </div>
                    ))}
                </div>







</span>

<span hidden = {tmpH2}>


<div className = 'loadingPage'>
<img src={logo} className="App-logo" alt="logo" />

</div>

    </span>


     

            </div>

        </>
    );
};



export default Home;